import {
	getSearchNodes,
	SearchNodeModel
} from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { EMPTY_ARRAY } from "client/Misc/utils";
import create, { UseStore } from "zustand";
import { AutoFetchStoreData, createAutoFetchStore } from "client/zustand/createAutoFetchStore";

const searchNodesStore = createAutoFetchStore<readonly SearchNodeModel[]>(
	EMPTY_ARRAY,
	getSearchNodes
);

export const useSearchNodesStore: UseStore<AutoFetchStoreData<readonly SearchNodeModel[]>> = create(searchNodesStore);